<template>
    <div class="rasoStep">
        <div class="rasoStep-flex flex align-cen">
            <div class="label isRequild">步骤名称：</div>
            <div class="ipt">
                 <el-input placeholder="请输入步骤名称" v-model="propData.stepName" clearable> </el-input>
            </div>
        </div>
              <div class="rasoStep-flex flex align-cen">
            <div class="label isRequild">关联过程：</div>
            <div class="ipt">
               <el-select v-model="propData.processName" clearable placeholder="请选择">
                        <el-option
                        v-for="item1 in itemList"
                        :key="item1.id"
                        :label="item1.processName"
                        :value="item1.id" 
                        >
                        </el-option>
                    </el-select>
            </div>
        </div>
         <div class="rasoStep-flex flex align-cen">
             <div class="label isRequild">步骤类型：</div>
            <el-radio v-model="propData.stepType" label="1"  v-removeAriaHidden>普通步骤</el-radio>
            <el-radio v-model="propData.stepType" label="2"  v-removeAriaHidden>质量步骤</el-radio>
            <el-radio v-model="propData.stepType" label="3"  v-removeAriaHidden>扣分步骤</el-radio>
           </div>
                <div class="rasoStep-flex flex align-cen">
            <div class="label isRequild">步骤分值：</div>
            <div class="ipt">
                 <el-input placeholder="请输入步骤分值" v-model="propData.score" clearable> </el-input>
            </div>
        </div>
         <div class="rasoStep-flex flex align-cen">
            <div class="label isRequild">顺序关系：</div>
            <el-radio v-model="propData.isOrder" label="0">无顺序关系</el-radio>
            <el-radio v-model="propData.isOrder" label="1">有顺序关系</el-radio>
        </div>
        <!-- 前提条件 -->
        <div class="rasoStep-flex">
             <div class="label isRequild">前提条件</div>
             <div class="stepCond flex align-cen" 
             v-for="(item,index) in result0"
             >
                <div class="stepCond-1" v-if="item.cond1">
                     <el-select v-model="item.cond1" placeholder="请选择">
                        <el-option
                        v-for="item1 in stepCond"
                        :key="item1"
                        :label="item1"
                        :value="item1" 
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="stepCond-1" v-if="!item.cond1"></div>
                <div class="stepCond-2">
                      <el-select v-model="item.tag" filterable clearable placeholder="请选择" @change="classChange(index,0)">
                        <el-option
                        v-for="item2 in instrumentItem"
                        :key="item2.tag"
                        :label="item2.tag + ' ' + item2.name"
                        :value="item2.tag" 
                        >
                        </el-option>
                    </el-select>
                </div>
                     <div class="stepCond-1">
                     <el-select v-model="item.tj" placeholder="请选择">
                        <el-option
                        v-for="item2 in stepCond1"
                        :key="item2"
                        :label="item2"
                        :value="item2" 
                        >
                        </el-option>
                    </el-select>
                </div>
                       <div class="stepCond-1" style="margin-left:15px">
                     <el-input placeholder="" v-model="item.tj1" clearable> </el-input>
                     </div>
                     <div class="stepCond-3" v-if="index > 0" @click="deletResult(index,0)">
                        <i class="el-icon-error"></i>
                     </div>
             </div>
             <div class="add-stepCond" @click="addStepCond(0)">
                添加一项
             </div>
        </div>
        <!-- 目标条件 -->
          <div class="rasoStep-flex" v-if="!propData.stepType || propData.stepType == '1' || propData.stepType == '3'">
             <div class="label isRequild">目标条件：</div>
                       <div class="stepCond flex align-cen" 
             v-for="(item,index) in result1"
             >
                <div class="stepCond-1" v-if="item.cond1">
                     <el-select v-model="item.cond1" placeholder="请选择">
                        <el-option
                        v-for="item1 in stepCond"
                        :key="item1"
                        :label="item1"
                        :value="item1" 
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="stepCond-1" v-if="!item.cond1"></div>
                <div class="stepCond-2">
                      <el-select v-model="item.tag" filterable clearable placeholder="请选择" @change="classChange(index,1)">
                        <el-option
                        v-for="item2 in instrumentItem"
                        :key="item2.tag"
                        :label="item2.tag + ' ' + item2.name"
                        :value="item2.tag" 
                        >
                        </el-option>
                    </el-select>
                </div>
                     <div class="stepCond-1">
                     <el-select v-model="item.tj" placeholder="请选择">
                        <el-option
                        v-for="item2 in stepCond1"
                        :key="item2"
                        :label="item2"
                        :value="item2" 
                        >
                        </el-option>
                    </el-select>
                </div>
                       <div class="stepCond-1" style="margin-left:15px">
                     <el-input placeholder="" v-model="item.tj1" clearable> </el-input>
                     </div>
                     <div class="stepCond-3" v-if="index > 0" @click="deletResult(index,1)">
                        <i class="el-icon-error"></i>
                     </div>
             </div>
                <div class="add-stepCond" @click="addStepCond(1)">
                添加一项
             </div>
          </div>
                    <div v-if="propData.stepType == '2'">
             <div class="rasoStep-flex ">
                <div class="label isRequild">步骤目标条件</div>
           </div>
                    <div class="rasoStep-flex  rasoStep-flex1 flex align-cen">
            <div class="label">质量点名称</div>
            <div class="ipt">
               <el-select v-model="qualityInfo.node" filterable clearable placeholder="请选择" @change="classChange1">
                        <el-option
                        v-for="item1 in instrumentItem"
                        :key="item1.tag"
                        :label="item1.tag + ' ' + item1.name"
                        :value="item1.tag" 
                        >
                        </el-option>
                    </el-select>
            </div>
        </div>
        <div class="rasoStep-flex rasoStep-flex1 flex align-cen">
            <div class="label">质量点设定值</div>
            <div class="ipt">
                 <el-input placeholder="请输入质量点设定值" v-model="qualityInfo.num" clearable> </el-input>
            </div>
        </div>
         <div class="rasoStep-flex rasoStep-flex1 flex align-cen">
            <div class="label">上偏差</div>
            <div class="ipt">
                 <el-input placeholder="请输入上偏差" v-model="qualityInfo.up" clearable> </el-input>
            </div>
        </div>
          <div class="rasoStep-flex rasoStep-flex1 flex align-cen">
            <div class="label">下偏差</div>
            <div class="ipt">
                 <el-input placeholder="请输入下偏差" v-model="qualityInfo.down" clearable> </el-input>
            </div>
        </div>
          <div class="rasoStep-flex rasoStep-flex1 flex align-cen">
            <div class="label">最大上偏差</div>
            <div class="ipt">
                 <el-input placeholder="请输入最大上偏差" v-model="qualityInfo.maxUp" clearable> </el-input>
            </div>
        </div>
          <div class="rasoStep-flex rasoStep-flex1 flex align-cen">
            <div class="label">最大下偏差</div>
            <div class="ipt">
                 <el-input placeholder="请输入最大下偏差" v-model="qualityInfo.maxDown" clearable> </el-input>
            </div>
        </div>
          </div>
           <div class="rasoStep-flex">
             <div class="label isRequild">结束条件：</div>
                       <div class="stepCond flex align-cen" 
             v-for="(item,index) in result2"
             >
                <div class="stepCond-1" v-if="item.cond1">
                     <el-select v-model="item.cond1" placeholder="请选择">
                        <el-option
                        v-for="item1 in stepCond"
                        :key="item1"
                        :label="item1"
                        :value="item1" 
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="stepCond-1" v-if="!item.cond1"></div>
                <div class="stepCond-2">
                      <el-select v-model="item.tag" filterable clearable placeholder="请选择" @change="classChange(index,2)">
                        <el-option
                        v-for="item2 in instrumentItem"s
                        :key="item2.tag"
                        :label="item2.tag + ' ' + item2.name"
                        :value="item2.tag" 
                        >
                        </el-option>
                    </el-select>
                </div>
                     <div class="stepCond-1">
                     <el-select v-model="item.tj" placeholder="请选择">
                        <el-option
                        v-for="item2 in stepCond1"
                        :key="item2"
                        :label="item2"
                        :value="item2" 
                        >
                        </el-option>
                    </el-select>
                </div>
                       <div class="stepCond-1" style="margin-left:15px">
                     <el-input placeholder="" v-model="item.tj1" clearable> </el-input>
                     </div>
                     <div class="stepCond-3" v-if="index > 0" @click="deletResult(index,2)">
                        <i class="el-icon-error"></i>
                     </div>
             </div>
                <div class="add-stepCond" @click="addStepCond(2)">
                添加一项
             </div>
          </div>
           <div class="rasoStep-flex flex align-cen">
            <div class="label isRequild">排序：</div>
            <div class="ipt">
                 <el-input placeholder="请输入步骤排序" v-model="propData.sort" clearable> </el-input>
            </div>
        </div>
    </div>
</template>
<script>
import {instrumentList,processList} from "@/api/index/index"   //仪表阀门列表
export default {
    name:'rasoStep',
    props: {
    propIndex:[String, Number],
    propAppId:[String, Number],
    propData: {
      type: Object,
      default: () => {
        return {}
      }, // 默认值
    },
  },
    data () {
        return {
             qualityInfo:{
            node:'',
            name:'',
            num:'',
            up:'',
            down:'',
            maxUp:'',
            maxDown:'',
            },
            itemList:[],
            stepCond:['与','或'],
            instrumentItem:[],
            condtionStr:'与',
            condtionStr1:'',
            result0:[],
            result1:[],
            result2:[],
            stepCond1:['=','>','<','>=','<=']
        }
    },
    created () {
        this.getinstrumentList();
        this.getprocessList()
        let newarr = ['stepStart','stepTarget','stepTerminal']
        newarr.forEach((t,index) =>{
              if(index == 1 && this.propData.stepType == 2){
                   let qarr= this.propData.stepTarget.split(',');
                   this.qualityInfo = {
                            node:qarr[0],
                            name:qarr[1],
                            num:qarr[2],
                            up:qarr[3],
                            down:qarr[4],
                            maxUp:qarr[5],
                            maxDown:qarr[6],
                            }
                 }else{
                this[`result${index}`] = []
            let str = this.propData[t]
                let arr = []
                str = str.trim().replace(/;$/, '');  
                arr = str.split(';')
                this[`result${index}`] = arr.map(item =>{
                    // 分割字符串为数组，
                    let parts = item.split(',');
                    // 构造对象  
                        return {  
                            cond1: parts[0],  
                            tag: parts[1],  
                            name: parts[2],  
                            tj: parts[3],  
                            tj1: parts[4]  
                        };
                })
                 }
        })
    },
    methods: {
           // 获取过程列表
        getprocessList(){
            processList({paperId:this.propData.paperId})
            .then(res =>{
                this.itemList = res.data
            })
        },
        // 父组件点击确定
        emitData(){
             if(!this.propData.stepName) return this.$util.Notifi('请输入步骤名称', "error", "fa-exclamation-circle");  
          let newarr = ['stepStart','stepTarget','stepTerminal']
             let continueExecution = true; // 标志变量，用于指示是否继续执行后续代码  
            for (let index = 0; index < newarr.length; index++) {  
                let t = newarr[index]; 
                let r = this[`result${index}`]
                if(this.propData.stepType != '2'){
                for (let  index1 in r) {
                    if(!r[index1].tag || !r[index1].tj1){
                        this.$util.Notifi(index == 0 ? `请补全第${Number(index1) + 1}条起始条件` : index == 1 ? `请补全第${Number(index1) + 1}条目标条件` : `请补全第${Number(index1) + 1}条结束条件`, "error", "fa-exclamation-circle");
                    continueExecution = false;
                    break;
                    } 
                }
                }else{
                    if(t != 'stepTarget'){
                 for (let  index1 in r) {
                    if(!r[index1].tag || !r[index1].tj1){
                        this.$util.Notifi(index == 0 ? `请补全第${Number(index1) + 1}条起始条件` : index == 1 ? `请补全第${Number(index1) + 1}条目标条件` : `请补全第${Number(index1) + 1}条结束条件`, "error", "fa-exclamation-circle");
                    continueExecution = false;
                    break;
                    } 
                    }
                    }
                }
                if(!continueExecution){
                    break; // 退出循环 
                }else{
                let formattedStrings = this[`result${index}`].map(item => `${item.cond1},${item.tag},${item.name},${item.tj},${item.tj1}`);
                this.propData[t] = formattedStrings.join(';');
                }
            }

             if(this.propData.stepType != '2'){
                let qualityArr = ['node','name','num','up','down','maxUp','maxDown']
                for (let i = 0; i < qualityArr.length; i++) { 
                    if(!this.qualityInfo[qualityArr[i]] && qualityArr[i] != 'name') return this.$util.Notifi(`请输入质量选项`,'error','fa-exclamation-circle') 
                 }
                let valuesInOrder = qualityArr.map(key => this.qualityInfo[key]);  
                this.propData.stepTarget = valuesInOrder.join(',');
                // stepTarget
             }
        
          if(!this.propData.score) return this.$util.Notifi('请输入步骤分值', "error", "fa-exclamation-circle");  
             if (continueExecution) { 
                this.$emit('emitFun', this.propData,this.propIndex);
             }
          
        },
        // 条件筛选
        classChange(index,type){
            // type:1前提条件，2目标条件、3结束条件
            this.instrumentItem.filter(item =>{
               if(item.tag == this[`result${type}`][index].tag){
                this[`result${type}`][index].name = item.name
               }
            })
        },
         // 质量步骤选择阀门
        classChange1(){
            this.instrumentItem.filter(f =>{if(f.tag == this.qualityInfo.node) {this.qualityInfo.name = f.name}})
            // this.qualityInfo.name = data.name
        },
        // 删除前提条件选项
        deletResult(index,type){
              let delet= this[`result${type}`].filter((item,sy)=> sy != index) 
              this[`result${type}`] = delet
        },
        // 添加前提条件
        addStepCond(type){
                this[`result${type}`].push({
                cond1: "与",
                tag: "",
                name:"",
                tj:"=",
                tj1:""
            });
        },
        getinstrumentList(){
            instrumentList({appId:this.propAppId,search:''})
            .then(res =>{
                this.instrumentItem = res.data
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.rasoStep{
    height: 70vh;
    overflow-y: scroll;
    margin-bottom: 10px;
.rasoStep-flex{
    padding-bottom: 10px;
    padding-left: 10px;
    .label{
        position: relative;
        font-weight: bold;
    }
    .isRequild::before{
        content: '*';
        color: #f56c6c;
        position: absolute;
        left: -10px;
        font-size: 16px;
        font-weight: bold;
        
    }
}
.rasoStep-flex1{
    .label{
        width: 100px;
        text-align: left;
    }
}
.stepCond{
     padding: 15px 0 0 0;
     .stepCond-2{
        margin: 0 15px;
     }
     .stepCond-3{
        margin-left: 15px;
        font-size: 18px;
        cursor: pointer;
     }
}
.add-stepCond{
    display: block;
    margin-left: 115px;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 150px;
    text-align: center;
    color: #fff;
    height: 40px;
    border-radius: 4px;
    background-color: #36aafd;
    line-height: 40px;
    cursor: pointer;
}
}
::v-deep{
    .stepCond-1{
        width: 100px;
        .el-select{
            text-align: center;
            .el-input--suffix .el-input__inner{
                text-align: center;
            }
        }
    }
}
</style>